var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.innerVisible,
        direction: "btt",
        size: "98%",
        "append-to-body": true,
        "destroy-on-close": true,
        "with-header": true,
        "close-on-press-escape": false,
        modal: true,
        "before-close": _vm.handleClose,
        "custom-class": "compose-email-drawer",
        "show-close": _vm.mode == "compose",
        withHeader: _vm.mode == "compose",
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
        [_vm._v(" " + _vm._s(_vm.drawerTitle) + " ")]
      ),
      _c("div", { staticClass: "compose-box" }, [
        _c(
          "div",
          { staticClass: "compose-wrap" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "compose-form",
                attrs: { model: _vm.form, "label-width": "80px" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "收件人" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入收件人，多个以分号分隔",
                        size: "small",
                      },
                      model: {
                        value: _vm.form.to,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "to", $$v)
                        },
                        expression: "form.to",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "抄送" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入抄送人，多个以分号分隔",
                        size: "small",
                      },
                      model: {
                        value: _vm.form.cc,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cc", $$v)
                        },
                        expression: "form.cc",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "主题" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入主题", size: "small" },
                      model: {
                        value: _vm.form.subject,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "subject", $$v)
                        },
                        expression: "form.subject",
                      },
                    }),
                  ],
                  1
                ),
                _c("el-form-item", { attrs: { label: "附件" } }, [
                  _c(
                    "div",
                    { staticClass: "attachment-bar" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", icon: "el-icon-upload2" },
                          on: { click: _vm.triggerFileSelect },
                        },
                        [_vm._v("上传附件")]
                      ),
                      _c("input", {
                        ref: "fileInput",
                        staticStyle: { display: "none" },
                        attrs: { type: "file", multiple: "" },
                        on: { change: _vm.handleFileSelect },
                      }),
                    ],
                    1
                  ),
                  _vm.form.attachments.length > 0
                    ? _c(
                        "div",
                        { staticClass: "attachment-list" },
                        _vm._l(_vm.form.attachments, function (file, idx) {
                          return _c(
                            "div",
                            { key: idx, staticClass: "attachment-tag" },
                            [
                              _c("i", { staticClass: "el-icon-document" }),
                              _c(
                                "span",
                                {
                                  staticClass: "file-name",
                                  attrs: { title: file.name },
                                },
                                [_vm._v(_vm._s(file.name))]
                              ),
                              _c("i", {
                                staticClass: "el-icon-close remove-icon",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeAttachment(idx)
                                  },
                                },
                              }),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
                _c(
                  "el-form-item",
                  { staticClass: "editor-item", attrs: { label: "正文" } },
                  [
                    _c("vue-editor", {
                      staticClass: "email-editor",
                      model: {
                        value: _vm.form.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "content", $$v)
                        },
                        expression: "form.content",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.mode !== "compose" && _vm.replyEmail
              ? _c("div", { staticClass: "original-email" }, [
                  _c("div", { staticClass: "original-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.mode == "forward" ? "转发" : "") +
                        _vm._s(_vm.mode == "reply" ? "回复原" : "") +
                        "邮件 "
                    ),
                  ]),
                  _c("div", { staticClass: "original-box" }, [
                    _c("div", { staticClass: "original-header" }, [
                      _c("div", { staticClass: "original-row" }, [
                        _c("span", { staticClass: "original-label" }, [
                          _vm._v("主题："),
                        ]),
                        _c("span", { staticClass: "original-value" }, [
                          _vm._v(_vm._s(_vm.replyEmail.subject)),
                        ]),
                      ]),
                      _c("div", { staticClass: "original-row" }, [
                        _c("span", { staticClass: "original-label" }, [
                          _vm._v("发件人："),
                        ]),
                        _c("span", { staticClass: "original-value" }, [
                          _vm._v(_vm._s(_vm.replyEmail.senderName)),
                        ]),
                      ]),
                      _c("div", { staticClass: "original-row" }, [
                        _c("span", { staticClass: "original-label" }, [
                          _vm._v("收件人："),
                        ]),
                        _c("span", { staticClass: "original-value" }, [
                          _vm._v(_vm._s(_vm.replyEmail.recipients)),
                        ]),
                      ]),
                      _vm.replyEmail.cc
                        ? _c("div", { staticClass: "original-row" }, [
                            _c("span", { staticClass: "original-label" }, [
                              _vm._v("抄送："),
                            ]),
                            _c("span", { staticClass: "original-value" }, [
                              _vm._v(_vm._s(_vm.replyEmail.cc)),
                            ]),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "original-row" }, [
                        _c("span", { staticClass: "original-label" }, [
                          _vm._v("发送时间："),
                        ]),
                        _c("span", { staticClass: "original-value" }, [
                          _vm._v(_vm._s(_vm.replyEmail.receivedDate)),
                        ]),
                      ]),
                      _vm.replyEmail.attachments &&
                      _vm.replyEmail.attachments.length
                        ? _c("div", { staticClass: "original-row" }, [
                            _c("span", { staticClass: "original-label" }, [
                              _vm._v("附件："),
                            ]),
                            _c(
                              "div",
                              { staticClass: "original-attachments" },
                              _vm._l(
                                _vm.replyEmail.attachments,
                                function (att, i) {
                                  return _c(
                                    "span",
                                    {
                                      key: i,
                                      staticClass: "original-att-item",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-document",
                                      }),
                                      _vm._v(" " + _vm._s(att.fileName) + " "),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", {
                      staticClass: "original-body",
                      domProps: { innerHTML: _vm._s(_vm.replyEmail.content) },
                    }),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "drawer-footer" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.handleClose } },
              [_vm._v("取消")]
            ),
            this.mode != "draft"
              ? _c(
                  "el-button",
                  {
                    staticClass: "draft",
                    attrs: { size: "small", type: "info", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleSend(true)
                      },
                    },
                  },
                  [_vm._v("存草稿")]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                staticClass: "send",
                attrs: { size: "small", type: "primary", loading: _vm.loading },
                on: { click: _vm.handleSend },
              },
              [_vm._v("发送")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }